import React, { Component } from 'react'
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react';
import '../css/Footer.css'
import '.././App.css';
import auth from '../auth'

class CustomFooter extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (

            // <footer className="footer footer-static navbar-shadow">
            //     <p className="clearfix blue-grey lighten-2 mb-0">
            //         <span className="float-md-left d-block d-md-inline-block mt-25">COPYRIGHT © 2021<a className="text-bold-400 grey darken-2" href="https://altpay.biz/" target="_blank">ALTPAY,</a>All rights Reserved</span><span className="float-md-right d-none d-md-block"><a href="https://www.shell.com.pk/terms-of-use/general-terms-and-conditions-for-shell-card.html' in 'Terms and Conditions">Terms &amp; Conditions |</a><a href="https://www.shell.com.pk/privacy.html' in 'Privacy">Privacy Policy |</a><a href="https://www.shell.com.pk/cookie-policy.html' in 'Cookie Policy">Cookie Policy |</a><a href="https://www.shell.com.pk/shell-fuel-card/shell-fuel-card/shell-fuel-card-contacts.html">Contact Us</a></span>
            //     </p>
            // </footer>
            <footer class="page-footer font-small blue footer navbar-shadow">

                <p className="clearfix blue-grey lighten-2 mb-0">
                    <span className="float-md-left d-block d-md-inline-block mt-25">COPYRIGHT © 2021<a className="text-bold-400 grey darken-2" href="https://altpay.biz/" target="_blank">ALTPAY,</a>All rights Reserved</span><span className="float-md-right d-none d-md-block"><a href="https://www.shell.com.pk/terms-of-use/general-terms-and-conditions-for-shell-card.html' in 'Terms and Conditions">Terms &amp; Conditions |</a><a href="https://www.shell.com.pk/privacy.html' in 'Privacy">Privacy Policy |</a><a href="https://www.shell.com.pk/cookie-policy.html' in 'Cookie Policy">Cookie Policy |</a><a href="https://www.shell.com.pk/shell-fuel-card/shell-fuel-card/shell-fuel-card-contacts.html">Contact Us</a></span>
                </p>

            </footer>
        );
    }

}


export default CustomFooter;